<template>
    <div class="updateMobile">
        <van-nav-bar
                title="更换手机"
                left-arrow
                @click-left="onClickLeft"
        />
        <van-row>
            <van-col span="24">
                <strong>为确认身份，我们仍需验证您的安全手机</strong>
                <p>点击发送短信按钮，将会发送一条有验证码的短信至手机<span style="color: #FF0000;">{{oldMobile}}</span></p>
            </van-col>
        </van-row>

        <van-cell-group v-show="showOldMobileSmsCode">
            <van-field
                    v-model="oldMobileSmsCode"
                    center
                    clearable
                    label="短信验证码"
                    placeholder="请输入短信验证码"
            >
                <van-button slot="button" size="small" type="primary" @click="sendSmsCode" v-show="!hasSendSms">发送验证码</van-button>
                <van-button slot="button" size="small" disabled type="primary" v-show="hasSendSms">{{second}}秒后重新获取</van-button>

            </van-field>
        </van-cell-group>
            <van-button type="warning"  v-show="showSendBtn"   block @click="sendSmsCode">发送短信</van-button>
        <van-button type="primary"     v-show="showConfirmBtn" block @click="confirmOldMobileSmsCode">确定</van-button>
    </div>
</template>

<script>
import {Button, Cell, CellGroup, Col, Field, NavBar, Row, Toast} from 'vant'
export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [NavBar.name]: NavBar,
    [Field.name]: Field,
    [Toast.name]: Toast
  },
  data() {
    return {
      oldMobile: '',
      oldMobileSmsCode: '',
      showOldMobileSmsCode: false,
      hasSendSms: false,
      second: 60,
      showSendBtn: true,
      showConfirmBtn: false
    }
  },
  mounted() {
    // this.init()
  },
  methods: {
  //   init() {
  //     const user = storage.getUser()
  //     this.oldMobile = util.formatMobile(user.mobile)
  //   },
  //   onClickLeft() {
  //     this.$router.go(-1)
  //   },
  //   sendSmsCode() {
  //     this.showSendBtn = false
  //     this.showConfirmBtn = true
  //     this.hasSendSms = true
  //     this.showOldMobileSmsCode = true
  //     userApi.sendSmsCode(this.oldMobile).then( response => {
  //       this.setTimeOut()
  //       const smsCode = response.data
  //       Toast('提示：测试阶段不发送短信验证码：'+smsCode)
  //     })
  //
  //   },
  //   setTimeOut() {
  //     let timer = setTimeout(() => {
  //       this.setTimeOut()
  //       if (this.second > 0) {
  //         this.second--
  //       }
  //     }, 1000)
  //     if (this.second <= 0) {
  //       this.hasSendSms = false
  //       this.second = 60
  //       clearTimeout(timer)
  //     }
  //   },
  //   confirmOldMobileSmsCode() {
  //     Toast('敬请期待')
  //   },
  //   submit() {
  //     Toast('敬请期待')
  //     return
  //     if (!this.userName || this.userName === '') {
  //       Toast('请输入姓名')
  //       return
  //     }
  //     userApi.updateUserName(this.userName).then(response => {
  //       store.dispatch('app/toggleUser', response.data)
  //       this.$router.go(-1)
  //     })
  //   }
  }
}

</script>

<style lang="less">
    .updateMobile {
        .van-row{
            padding:16px;
        }
        .van-col{
            background-color: #f8f8f8;
        }
    }
</style>
